import { MapScaleRotate } from '@openlayers/MapScaleRotate';
import { MapOverlays } from '@openlayers/ol-overlays';
import { fitFeature, latLonToEN, panTo } from '@openlayers/ol-utils';
import { LogpointsLinecodePanel } from '@pages/map/actions/LogpointsLinecodePanel';
import { MapDocumentsEditor } from '@pages/map/actions/MapDocumentsEditor';
import { mapRootStore, mapStateFacade, mapTools, mapUI, mapWrapper } from '@pages/map/map';
import { StationAndModelInfoBoxDesktop } from '@pages/map/ui/StationAndModelInfoBoxDesktop';
import { Ajax, Ajax2 } from '@shared/Ajax';
import { Events } from '@shared/Events';
import { ImagesUploaderDialog } from '@shared/images/ImageUploaderDialog';
import { LogpointsCreateManual } from '@shared/logpoints/ui/LogpointsCreateManual';
import { Drawer } from '@shared/ui-native/Drawer';
import { Splitter } from '@shared/ui-native/Splitter';
import { TreeNode } from '@shared/ui-native/Tree';
import { Button } from '@shared/ui-react/Button';
import { Catch } from '@shared/ui-react/Catch';
import { MapLoader } from '@shared/ui-react/MapLoader';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { ImagesEditor } from '../actions/ImagesEditor';
import { Map2dSidebar } from './sidebar';
import { Map2dToolbar } from '@pages/map/tools/Map2dToolbar';
import { cs } from '@shared/utils/utils-classname';
import * as React from 'react';
import './map-ui.scss';
import { Notify } from '@shared/ui-native/Notify';
import { transform as olTransform } from 'ol/proj';
import { ProgressBar } from 'primereact/progressbar';

@observer
export class Map2dUI extends React.Component {
    mapScaleRotate: MapScaleRotate;
    stationAndModelInfoBox: StationAndModelInfoBoxDesktop;
    mapPanels: Map2dSidebar;
    @observable toolbarDisabled = true;
    private sidebarEl: HTMLDivElement = null;

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    componentDidMount(): void {
        Events.on('drawer-open.editor', () => this.onDrawerOpen());
        Events.on('drawer-close.editor', () => this.onDrawerClose());

        $('#app__header__menu a').on('click', () => {
            mapStateFacade.liveUserState.save();
            return true;
        });

        new Splitter($('#map-sidebar-holder'), null, {
            startWidth: Math.min(430, window.innerWidth - 40),
        });

        try {
            const ro = new ResizeObserver((entries) => {
                const target = entries[0].target as HTMLDivElement;
                const left = parseFloat(target.style.left.replace('px', ''));
                mapRootStore.sidebarWidth = left < 0 ? null : entries[0].contentRect.width;
            });
            ro.observe(this.sidebarEl);
        } catch {}

        this.toolbarDisabled = false;
    }

    render() {
        return (
            <>
                <div id='map-loader-wrapper'>
                    <Catch>
                        <MapLoader />
                    </Catch>
                </div>

                <div id='window-manager-wrapper'></div>

                <div id='map-sidebar-holder' ref={el => (this.sidebarEl = el)} className={mapRootStore.mobileView ? 'mobile' : undefined}>
                    <Catch>
                        <Map2dSidebar
                            ref={el => {
                                if (el) {
                                    this.mapPanels = el;
                                }
                            }}
                        />
                    </Catch>
                </div>

                <div id='controls' style={{ position: 'fixed', top: 60, right: 20 }} className={cs({ 'fade-disable': this.toolbarDisabled })}>
                    <Catch>
                        <Map2dToolbar />
                    </Catch>
                </div>

                <div id='map-scale-rotate'>
                    <Catch>
                        <MapScaleRotate mapInstance={mapWrapper.getInstance()} ref={el => (this.mapScaleRotate = el)} />
                    </Catch>
                </div>



                <div style={{ position: 'fixed', top: 0, left: 0, width: 0, height: 0 }}>
                    <Catch>
                        <StationAndModelInfoBoxDesktop ref={el => (this.stationAndModelInfoBox = el)} />
                    </Catch>
                </div>

                <div style={{ display: 'none' }}>
                    <ProgressBar mode='indeterminate' />
                </div>
            </>
        );
    }

    hideDialog() {
        MapOverlays.hideDialog(mapWrapper.getInstance());
    }

    hideContextMenu() {
        MapOverlays.hideContextMenu(mapWrapper.getInstance());
    }

    editImage(imageId: number) {
        ImagesEditor.openForId(imageId, mapRootStore.imagesStore);
    }

    editDocument(documentId: number) {
        const item = mapRootStore.documentsStore.getById(documentId);
        MapDocumentsEditor.openDrawer([item], mapRootStore.documentsStore, mapRootStore.treeData, mapWrapper, mapTools);
    }

    // todo move to map actions
    createLogpoint = (lat: number, lon: number) => {
        const [n, e] = latLonToEN(lat, lon);
        const map = mapWrapper.getInstance() as any;
        const dialog = MapOverlays.showDialog(map, '', n, e, null);

        const getSelectedId = () => {
            const selected = this.mapPanels.panels.logpoints.genericComponent.tree.getSelected();

            if (selected) {
                if (selected.isFile()) {
                    return {
                        folderId: selected.parent.id,
                        modelId: selected.id,
                    };
                } else {
                    return {
                        folderId: selected.id,
                    };
                }
            } else {
                return {
                    folderId: kuura.getRootFolderId(),
                };
            }
        };

        setTimeout(() => {
            const selected = getSelectedId();

            Ajax({
                url: 'api/1/project/' + kuura.getProjectId() + '/convert_lat_lon.json',
                data: { lat, lon },
            }).done(resp => {
                const realE = resp.coords.e.toFixed(3);
                const realN = resp.coords.n.toFixed(3);

                ReactUtils.safeRender(
                    <div className='card padded-half arrow-bottom' style={{ width: 420 }}>
                        <LogpointsCreateManual
                            lat={lat.toFixed(10) + ''}
                            lon={lon.toFixed(10) + ''}
                            n={realN}
                            e={realE}
                            z={0}
                            treeData={mapRootStore.treeData}
                            defaultFolderId={selected.folderId}
                            defaultModelId={selected.modelId}
                            defaultAlignmentId={mapWrapper.featureLayers.alignments.getActiveAlignment().modelId}
                            onClose={() => MapOverlays.hideAllOverlays(map)}
                            onSave={logpoint => {
                                const feature = mapWrapper.featureLayers.logpoints.drawOne(logpoint);
                                feature.set('forceShow', true);
                                this.mapPanels.panels.logpoints.genericComponent.renderLogpointFolderCounts();
                            }}
                        />
                    </div>,
                    dialog.getElement()
                );
            });

            // center point to pan to
            const availWidth = window.innerWidth - $('#map-sidebar-holder').width() + 20;
            const pixel = map.getPixelFromCoordinate([n, e]);
            pixel[0] -= (window.innerWidth - availWidth) * 0.4;
            pixel[1] -= window.innerHeight * 0.35;
            const newCoord = map.getCoordinateFromPixel(pixel);
            panTo(map, newCoord[0], newCoord[1]);
        }, 1);
    };

    editLogpointsLinecode = () => {
        const drawerElement = Drawer.open();
        this.onDrawerOpen();
        ReactUtils.safeRender(<LogpointsLinecodePanel onClose={() => this.onLogpointsLinecodeClose()} />, drawerElement);
    };

    onLogpointsLinecodeClose = () => {
        Drawer.close();
        this.onDrawerClose();
    };

    openImageUploader = () => {
        ImagesUploaderDialog.open({
            treeData: mapRootStore.treeData,
            persistState: false,
            initialFolderId: () => {
                const initialFolderNode = this.mapPanels.panels.images.getSelected();
                return initialFolderNode ? initialFolderNode.id : null;
            },
            onQueueComplete: () => {
                mapRootStore.imagesStore.fetchAndSet();
            },
            getAlignment: () => {
                const activeId = mapWrapper.featureLayers.alignments.getActiveAlignment()?.modelId;
                const alignmentNode: TreeNode = activeId > 0 ? this.mapPanels.panels.models.tree.getById(activeId) : null;
                return {
                    alignmentName: alignmentNode ? alignmentNode.ajaxData.name : null,
                    station: mapUI.stationAndModelInfoBox?.stationInfo?.b,
                };
            },
            getActiveModelName: () => {
                const selected = this.mapPanels.panels.models.tree.getSelected();
                if (selected && !selected.isFolder()) {
                    return selected.ajaxData.name;
                }
                return '';
            },
            onClickDone: ImagesUploaderDialog.close,
        });
    };

    onDrawerOpen = () => {
        this.toolbarDisabled = true;
        Events.trigger('map-hide-overlays');
        mapTools.deactivateAllTools();
    };

    onDrawerClose = () => {
        this.toolbarDisabled = false;
        mapTools.deactivateAllTools();
    };

    openCrossSectionWindowForCurrentStation = () => {
        mapTools.openCrossSectionWindow(this.stationAndModelInfoBox.stationInfo.station);
    };

    fitActiveAlignment = () => {
        const map = mapWrapper.getInstance();
        const activeFeature = mapWrapper.featureLayers.alignments.activeAlignmentFeature;

        if (!activeFeature) {
            Notify.warn(__('js_general.nothing_on_map') || 'Nothing to fit');
            return;
        }

        fitFeature(map, activeFeature);
    };

    panToStation = () => {
        let station = prompt(__('logpoints.filter_station_number') + ':');
        if (station == null) {
            return;
        }

        station = station.trim().replace(',', '.');
        if (!$.isNumeric(station)) {
            Notify.error('Invalid station');
            return;
        }

        Ajax2({
            url: kuura.getContextPath() + '/api/1/coords/stationCoordsByStation.json',
            params: {
                projectId: kuura.getProjectId(),
                station,
                alignmentId: mapRootStore.activeAlignment.modelId,
                alignmentIndex: mapRootStore.activeAlignment.index,
            },
        }).then(
            (resp: {
                station: {
                    lat: number;
                    lon: number;
                };
            }) => {
                if (resp.station.lat && resp.station.lat) {
                    const NE: Coordinate = olTransform([resp.station.lon, resp.station.lat], 'EPSG:4326', 'EPSG:3857');
                    mapWrapper.clickMarkerLayer.drawClickMarker(...(NE as [number, number]));
                    mapWrapper.panTo(NE[0], NE[1]);
                } else {
                }
            }
        );
    };
}
